export const containerStyles = {
  paddingRight: { lg: "0 !important" },
};

export const messageStyles = {
  width: "100%",
  fontSize: { xs: "1rem", md: "1rem", lg: "1.25rem" },
  display: "flex",
  justifyContent: "start",
  alignItems: "center",
};

export const avatarStyles = {
  width: { xs: 20, md: 24 },
  height: { xs: 20, md: 24 },
};

export const imageWrapperStyles = {
  height: { xs: 68, md: 145 },
  overflow: "hidden",
};

export const imageStyles = {
  width: "100%",
  height: "100%",
  objectFit: "contain",
};

// -------------- Fleet showcase -------------
export const getWrapperStyles = (index: number, isMaxContainer: boolean) => ({
  width: {
    md: index === 0 ? "70%" : index === 1 ? "80%" : "85%",
    xl:
      isMaxContainer && index === 0
        ? "calc(70% + 1vw)"
        : isMaxContainer && index === 1
          ? "calc(80% + 1vw)"
          : isMaxContainer && index === 2
            ? "calc(85% + 1vw)"
            : index === 0
              ? "70%"
              : index === 1
                ? "80%"
                : "85%",
  },
  maxWidth: index === 0 ? 169 : index === 1 ? 206 : 253,
  mx: "auto",
})

export const getImageWrapperStyles = (index: number) => ({
  height: "auto",
  overflow: "hidden",
  mx: "auto",
  width: "100%",
  mb: { md: index === 0 ? 2 : 0 },

  img: {
    width: "100%",
    height: "auto",
    objectFit: "contain",
  },
})